import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AssetPerformanceKPILineDataDashboard } from '../services/getAssetPerformanceKPIData'

export interface AssetPerformanceKPIDataState {
  isLoading: boolean
  errorMessage: string | null
  AssetPerformanceKPIData: AssetPerformanceKPILineDataDashboard | null
  httpStatus: number | null
}

// Initial state of the slice
const initialState: AssetPerformanceKPIDataState = {
  AssetPerformanceKPIData: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const AssetPerformanceKPIGraphDataState = createSlice({
  name: 'AssetPerformanceKPIGraphData',
  initialState,
  reducers: {
    AssetPerformanceKPIDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        AssetPerformanceKPIData: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    AssetPerformanceKPIDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        AssetPerformanceKPIData: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    AssetPerformanceKPIDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        AssetPerformanceKPIData: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  AssetPerformanceKPIDataLoadingAction,
  AssetPerformanceKPIDataUpdateAction,
  AssetPerformanceKPIDataErrorAction
} = AssetPerformanceKPIGraphDataState.actions

export default AssetPerformanceKPIGraphDataState.reducer
